// This is optional but highly recommended
// since it prevents memory leak
import { createIntl, createIntlCache } from "react-intl";

import { messages } from "./en-US.js";
import type { SelMessageProps } from "./SelMessage.tsx";

const intlCache = createIntlCache();
export const intl = createIntl(
  {
    locale: "en-US",
    messages: messages,
  },
  intlCache,
);

export const selMessage = (props: SelMessageProps): string => {
  const values = props.values ? { ...msgFormatting, ...props.values } : msgFormatting;

  return intl.formatMessage({ id: props.id }, values);
};

// In case of pure string, mostly in headings, we don't format with html element and bold text
const msgFormatting = {
  emph: ([chunk, ..._]: string[]) => {
    return chunk;
  },
};
